import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QRDropdown } from 'src/app/models/qr-dropdown.model';

@Component({
  selector: 'app-config-download-excel-objectives',
  templateUrl: './config-download-excel-objectives.component.html',
  styleUrls: ['./config-download-excel-objectives.component.scss'],
})
export class ConfigDownloadExcelObjectivesComponent implements OnInit {
  @Input() value: string[] = [];
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  dropdownYears: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: [],
  };

  ngOnInit(): void {
    if (this.value) this.dropdownYears.options = this.value;
  }

  dropdownYearsChange(event: any) {
    if (event) this.change.emit(event);
  }
}
